import { cn } from "@/lib/utils/cn";

export function Logo({
  className,
  showWordmark = true,
  invert = false,
}: {
  className?: string;
  showWordmark?: boolean;
  invert?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div
        aria-hidden
        className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-grad text-[14px] font-bold leading-none tracking-tight text-white shadow-soft"
      >
        iG
      </div>
      {showWordmark && (
        <span
          className={cn(
            "text-[16px] font-bold tracking-tight",
            invert ? "text-white" : "text-ink",
          )}
        >
          Imob<span className={invert ? "text-brand-400" : "text-brand-600"}>Go</span>
        </span>
      )}
    </div>
  );
}
